import { render } from "./BaseFnbTopNav.vue?vue&type=template&id=8d780564&scoped=true"
import script from "./BaseFnbTopNav.vue?vue&type=script&lang=js"
export * from "./BaseFnbTopNav.vue?vue&type=script&lang=js"

import "./BaseFnbTopNav.vue?vue&type=style&index=0&id=8d780564&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d780564"]])

export default __exports__